export const API_URL = process.env.REACT_APP_API_URL;
export const SOCKET_URL = "https://hallgaadminapi.appgrowthcompany.com";

export const END_POINTS = {
  login: "onboarding/login",
  upload: "media/single",
  get_user: "onboarding",
  logout: "onboarding/logout",
  forgotPassword: "onboarding/forgot-password",
  verifyOtp: "onboarding/reset-password",
  resetPassword: "onboaring/reset-password/",
  changePassword: "onboarding/change-password",
  uploadMedia: "media/upload/",
  dashboardData: "onboarding/dashboard",
  changeGraphStatus: "onboarding/changeGraphStatus",
  cmsSetting: "cmsSetting",
  receivedNotification: "notification/receivedNotification",
  category: "category",
  customer: "customer",
  propertydetail: "propertydetail",
  issue: "issue",
  invoice: "customer/invoice",
  faq: "faq",
  cms: "cms",
  offer: "offer",
  accessRole: "subadminaccess",
  rating: "rating",
  customerSupport: "customersupport",
  banner: "banner",
  venueStorage: "venue-storage",
  booking: "booking",

  //USER
  user: "user",
  //venue-storage
  getVenueStorage: "/venue-storage",
  changeVenueStorageStatus: "/venue-storage/togle",
  acceptRejectVenueStorage: "/venue-storage/ownerStatus",
  deleteVenueStorage: "/venue-storage/",
  addVenue: "/venue-storage",
  exportVenueStorage: "/venue-storage/export",
  venueStorgeToggle: "venue-storage/togle",
  //facility
  facility: "/facility",
  //News
  News: "news",
  //Discount
  discount: "coupon",
  exportDiscount: "coupon/export",

  //blog
  blog: "blog",

  //booking
  statusChange: "booking/ownerStatus",
  //dashboard
  getdashboard: "dashboard/adminList",
  userGraph: "dashboard/userGraph",
  venueGraph: "dashboard/venueGraph",
  bookingGraph: "dashboard/bookingGraph",
  tax: "tax",
  //access Role 
  role: "accessRole",

  //Loality point
  getPoint: "loyaltyPoint",

  //host Payout
  payout: "payout",
  updatePayout: 'payout/adminPay',

  //Refunds
  refund: "payment",
  updateRefund: "payment",
  refundStatus: "refund/status",
  refundDetails: "refund/details",

  //customerSupport
  getSupport: "support",

  // manage Payment
  getPayment: "payment/managePayment",

  // manage Notification
  notification: "notification"
};
